import { render, staticRenderFns } from "./VInput.vue?vue&type=template&id=e3884e36&scoped=true"
import script from "./VInput.vue?vue&type=script&lang=js"
export * from "./VInput.vue?vue&type=script&lang=js"
import style0 from "./VInput.vue?vue&type=style&index=0&id=e3884e36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3884e36",
  null
  
)

export default component.exports